import radioConfig from "../config/radioConfig";

const NAV = [
  { label: "Inicio", href: "#inicio" },
  { label: "En vivo", href: "#en-vivo" },
  { label: "Programación", href: "#programacion" },
  { label: "La radio", href: "#la-radio" },
  { label: "Contacto", href: "#contacto" },
  { label: "App Android / iOS", href: "#app" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-[#05070B] border-t border-slate-800/80 pt-16 pb-28 md:pb-14 px-4 sm:px-8"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src={radioConfig.assets.logo}
              alt="Logo FM REAL 96.3"
              className="h-11 w-11 rounded-lg object-contain ring-1 ring-cyan-500/30"
            />
            <span className="font-heading font-extrabold text-white text-lg">
              FM REAL <span className="text-cyan-400">96.3</span>
            </span>
          </div>
          <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
            {radioConfig.city}, {radioConfig.province}, {radioConfig.country}.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.25em] font-mono text-slate-500 mb-4">
            Navegación
          </p>
          <ul className="space-y-2">
            {NAV.map((n) => (
              <li key={n.href}>
                <a
                  href={n.href}
                  className="text-sm text-slate-400 hover:text-cyan-400 transition-colors"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.25em] font-mono text-slate-500 mb-4">
            Medio asociado
          </p>
          <a
            href={radioConfig.lasBrenasDigitalUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-partner-link"
            className="inline-flex items-center gap-2 text-sm text-emerald-400 hover:text-emerald-300 transition-colors"
          >
            Las Breñas Digital ↗
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-slate-800/60">
        <a href="/privacidad.html" className="text-xs text-slate-400 hover:text-cyan-400 inline-block mb-4">Privacidad</a>
        <p className="text-xs text-slate-600 font-mono">
          © {new Date().getFullYear()} FM REAL 96.3 · Las Breñas, Chaco, Argentina.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
